import * as React from "react";
import {PageTitle} from "../../components/TitleBar/PageTitle";
import Collapse from '@mui/material/Collapse';
import EnhancedTable from "../../components/EnhancedTable/EnhancedTable";
import {Project} from "../../models/project";
import {projectListSelector} from "../../recoil/selectors/projectSelectors";
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

const listHeaders = {
    "Project": "name",
    "Organization": "organization",
    "Created": "ticket_created",
    "Description": "description"
};

const formatTableData = (projects: Project[]) => {
    const formattedProjects: any[] = []
    projects.forEach(project => {
        formattedProjects.push({
            name: project.name,
            organization: project.organization,
            ticket_created: new Date(project.ticket_created).toLocaleString(),
            description: project.description,
        });
    });
    return formattedProjects;
}

const getDetailInfo = (open: boolean, row: number) => {
    return (
        <TableRow>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <Box sx={{margin: 1}}>
                    <TableCell style={{paddingBottom: 0, paddingTop: 0}} colSpan={1}>
                        <Table>
                            <TableRow>
                                <TableCell>Next Runtime</TableCell>
                                <TableCell>test</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>Last Runtime</TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>Most Recent Associated Report</TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                        </Table>
                    </TableCell>
                </Box>
            </Collapse>
        </TableRow>
    )
}

export const ProjectContainer = () => {
    return (
        <Box>
            <PageTitle pageTitle="Projects" />
            {/*<EnhancedTable*/}
            {/*    title=""*/}
            {/*    selector={projectListSelector}*/}
            {/*    getDetailInfo={getDetailInfo}*/}
            {/*    formatMethod={formatTableData}*/}
            {/*    selectable={false}*/}
            {/*    headers={listHeaders}/>*/}
        </Box>
    )
}